import React, { Component } from 'react';
import { getStaffEventsDepartment } from "../../../services/widgetsService";
import FilterByYear from "../../Common/filters/FilterByYear";
import Chart from "react-google-charts";
import { messages } from '../../../utils/language-en.json';
 
class EventsStaffDepartmentWidget extends Component {
  mounted = false;
  state = {
    events: [],
    hasData: false
  }

  async componentDidMount() {
    this.mounted = true;
    this.mounted && this.getStaffEventsDepartmentData(new Date().getFullYear());
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  getStaffEventsDepartmentData = async (year) => {
    const { data } = await getStaffEventsDepartment(year);
    const eventsData =  [['Department', 'Qty']];
    var hasData = false;

    data.events.forEach((element) => {
      if (parseInt(element.total) > 0) {
        hasData = true;

        eventsData.push(
          [element.name, parseInt(element.total)]
        )
      }
    });

    this.setState({events: eventsData});
    this.setState({hasData: hasData});
    this.setState({title: data.title});
  }

  handleYearChange = async (itemSelected) => {
    const yearSelected = (itemSelected) ? itemSelected.value: new Date().getFullYear();
    this.getStaffEventsDepartmentData(yearSelected);
  };

  render() {
    const {
      events,
      hasData,
      title
    } = this.state;

    return (
      <div className="col-auto"> 
        <div className='DashboardList-item btn d-flex flex-column'>
          <h4><i className="fas fa-chart-area"></i>&nbsp;{title}</h4>
          <FilterByYear handleYearChange={this.handleYearChange}/>
          { !hasData 
            ? <div className="no-data">{messages.emptydata.widgetsMessage}</div>
            : 
            <Chart
              chartType="BarChart"
              loader={<div>Loading</div>}
              data={events}
              options={{
                backgroundColor: 'transparent',
                width: '100%',
                height: 180,
                legend: {
                  position: 'none'
                }
              }}
            />
          }
        </div>
      </div>
    )
  }
}

export default EventsStaffDepartmentWidget;